module.exports = __webpack_public_path__ + "static/media/Affiliate_WelcomeBonus_mobile.4bab2520.jpeg";